import type { CreditCardBrand } from '__generated__/globalTypes';

export type PaymentProvider_paymentMethod = {
  __typename: any;
  id: string;
  card: {
    __typename: any;
    last4: string;
    brand: CreditCardBrand;
  };
};

export enum WalletPaymentMethod {
  CRYPTO_WALLET = 'crypto_wallet',
  FIAT_WALLET = 'fiat_wallet',

  // @deprecated Use CRYPTO_WALLET instead. Kept for backward compatibility
  ETH_WALLET = 'eth_wallet',
}

export enum PaymentMethod {
  CRYPTO_WALLET = 'crypto_wallet',
  FIAT_WALLET = 'fiat_wallet',
  CREDIT_CARD = 'credit_card',
  NEW_CREDIT_CARD = 'new_credit_card',
  PAYMENT_REQUEST = 'payment_request',
  PAYPAL = 'paypal',
  KLARNA = 'klarna',

  // @deprecated Use CRYPTO_WALLET instead. Kept for backward compatibility
  ETH_WALLET = 'eth_wallet',
}

type CrediCardPaymentMethodSuffix = `credit_card_`;
export type CrediCardPaymentMethod = `${CrediCardPaymentMethodSuffix}${string}`;

export type OrderedPaymentMethod = PaymentMethod | CrediCardPaymentMethod;
